// The app view: the HAJEX BOLT APP's web build, served next to the website at
// <origin>/warehouse-app/. On the same origin it signs in with the website's
// session, so a shipper login (or one of its store users) can switch to the
// phone-friendly screens without signing in again.
//
// REACT_APP_WAREHOUSE_APP_URL overrides the address (for a build that serves
// the app elsewhere); by default it is this site's origin + /warehouse-app/,
// so dev-test and production each open their own copy.

export const APP_VIEW_PATH = "/warehouse-app/";

// Logins the app supports: shipper accounts and their store users. Warehouse
// (3PL), one-time shipper, admin, carrier and driver logins don't get it.
export const APP_VIEW_ROLES = ["Shipper", "ShipperUser"];

export const APP_VIEW_BANNER_KEY = "bolt.appViewBanner.dismissed";

// Phone-sized screens, where the website suggests the app view.
export const APP_VIEW_PHONE_QUERY = "(max-width: 820px)";

export const appViewUrl = (
  env = process.env,
  location = typeof window !== "undefined" ? window.location : null,
) => {
  const override = String(env?.REACT_APP_WAREHOUSE_APP_URL || "").trim();
  if (override) {
    return override;
  }
  const origin = location?.origin || "";
  return `${origin}${APP_VIEW_PATH}`;
};

export const canUseAppView = (user) =>
  Boolean(user && APP_VIEW_ROLES.includes(user.role));

const storageOf = (storage) => {
  if (storage) {
    return storage;
  }
  // Reading window.localStorage itself throws when site data is blocked.
  return typeof window !== "undefined" ? window.localStorage : null;
};

export const isAppViewBannerDismissed = (storage) => {
  try {
    return storageOf(storage)?.getItem(APP_VIEW_BANNER_KEY) === "1";
  } catch (e) {
    return false;
  }
};

export const dismissAppViewBanner = (storage) => {
  try {
    storageOf(storage)?.setItem(APP_VIEW_BANNER_KEY, "1");
  } catch (e) {
    // Storage is blocked (private window): the banner stays closed until the
    // page reloads.
  }
};
